import React from "react";
import StyledSubmitButton from "../../Buttons/StyledSubmitButton";

interface DataObject {
  [key: string]: any; // define your data object interface
}

interface Props {
  data: DataObject[]; // data to be included in the CSV file
}

/**
 * Convert provided data into a CSV string.
 * Expects:
 *    data[0] = header array (strings)
 */
const generateCSV = (data: DataObject[]): string => {
  if (!data.length) {
    return "";
  }
  const headers = data[0];
  return [headers.join(",")].join("\n");
};

const CSVGenerator: React.FC<Props> = ({ data }) => {
  /**
   * Trigger CSV file download
   */
  const handleDownload = () => {
    const csvData = generateCSV(data);
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "data.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <StyledSubmitButton
      onClick={handleDownload}
    >
      Sample
    </StyledSubmitButton>
  );
};

export default CSVGenerator;
